import { MutationCache, QueryClient } from '@tanstack/react-query';
import {
  ImitationViewOnlyError,
  isImitationActive,
} from 'src/api/imitationState';
import { notifyViewOnly } from 'src/api/notifyViewOnly';

declare module '@tanstack/react-query' {
  interface Register {
    mutationMeta: {
      /**
       * Opts a mutation out of the imitation write block below. Reserved for
       * the handful of calls that must still work while imitating — logging
       * out, and ending imitation itself — and mirrored by the backend's own
       * allowlist. Never add a real write here.
       */
      allowDuringImitation?: boolean;
    };
  }
}

const queryClient = new QueryClient({
  // One veto for every `useMutation` in the app, before the request is built.
  // The server is the security boundary (it 403s these regardless); this is
  // the UX layer, so the user gets one clear explanation instead of a generic
  // failure per button. Throwing here skips `mutationFn` entirely.
  mutationCache: new MutationCache({
    onMutate: (_variables, mutation) => {
      if (isImitationActive() && !mutation.meta?.allowDuringImitation) {
        notifyViewOnly();
        throw new ImitationViewOnlyError();
      }
    },
  }),
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
      gcTime: 5 * 60 * 1000, // 5 minutes (replaces cacheTime)
    },
  },
});

export default queryClient;
